import {
    corePalette,
    fadedPalette,
    greyPalette,
    pastelPalette,
    saturatedPalette,
    secondaryPalette,
    standardPalette,
    tempPalette
} from "./colorPalettes";

const paletteToSpectrum = palette => Object.values(palette).map(color => color);

/*
 Chart Colors Array
 */
export const chart = {
    spectrum: paletteToSpectrum(pastelPalette),
    palette: pastelPalette
};

/*
 Heatmap Colors Array
 */
export const heatMap = {
    spectrum: paletteToSpectrum(saturatedPalette),
    palette: saturatedPalette
};

/*
 Horse Race Segments Colors Array
 */
export const segmentedBar = {
    spectrum: paletteToSpectrum(tempPalette),
    palette: tempPalette
};

export const greys = {
    spectrum: paletteToSpectrum(greyPalette),
    palette: greyPalette
};

export const notifications = {
    palette: fadedPalette
};

/*
 System/Defaults
 */
export const typography = greyPalette.darkGrey;
export const black = greyPalette.black;
export const white = greyPalette.white;
export const grey = greyPalette.grey;
/*
 Utility
 */
export const disabled = greyPalette.medLtGrey;
export const error = standardPalette.coral;
export const warning = saturatedPalette.orange;
export const success = corePalette.green;
export const failure = standardPalette.coral;

/*
 Aesthetic
 */
export const primary = corePalette.blue;
export const secondary = corePalette.green;
export const accent = secondaryPalette.blueBright;
export const muted = greyPalette.grey;

/*
 Content
 */
export const status = {
    draft: primary,
    pending: primary,
    complete: secondary
};

export const baselineColor = greyPalette.darkGrey;
export const competitorColor = saturatedPalette.orange;
export const winnerColor = corePalette.green;

export const archived = muted;

export const sideNavBackground = greyPalette.medLtGrey;



// WEBPACK FOOTER //
// ./src/helpers/constants/colors.js